import React from 'react'
import Svg, { SvgType } from './Svg'

export default function(props: SvgType) {
  return (
    <Svg width="33" height="34" viewBox="0 0 33 34" fill="none" {...props}>
      <rect
        x="0.5"
        y="1.30957"
        width="32"
        height="32"
        rx="16"
        stroke="white"
        strokeOpacity="0.55"
      />
      <path
        d="M23.0625 11.6221C23.3164 11.6221 23.5361 11.7148 23.7217 11.9004C23.9072 12.0859 24 12.3057 24 12.5596V14.127L16.5 17.1299L9 14.127V12.5596C9 12.3057 9.09277 12.0859 9.27832 11.9004C9.46387 11.7148 9.68359 11.6221 9.9375 11.6221H23.0625ZM9 15.665L16.5 18.668L24 15.665V21.9346C24 22.1885 23.9072 22.4082 23.7217 22.5938C23.5361 22.7793 23.3164 22.8721 23.0625 22.8721H9.9375C9.68359 22.8721 9.46387 22.7793 9.27832 22.5938C9.09277 22.4082 9 22.1885 9 21.9346V15.665Z"
        fill="#286EFA"
      />
    </Svg>
  )
}
